import React, { ReactNode, forwardRef } from 'react';
import ItinerarySegmentBanner from '@kiwicom/orbit-components/lib/Itinerary/ItinerarySegment/ItinerarySegmentBanner';

type ItinerarySegmentBannerWithRefProps = {
  children: ReactNode;
  // href and onClick are injected by SmartFaqLink
  onClick?: () => void;
  href?: string;
};

/**
 * This component is a wrapper for ItinerarySegmentBanner which can handle the ref property.
 * It's used when wrapping the banner with the Next.js Link (e.g. SmartFaqLink component).
 *
 * @returns ItinerarySegmentBannerWithRef component
 */
// eslint-disable-next-line react/display-name
const ItinerarySegmentBannerWithRef = forwardRef<unknown, ItinerarySegmentBannerWithRefProps>(
  ({ children, onClick, href }, _ref) => {
    return (
      <a
        className="block no-underline"
        href={href}
        onClick={e => {
          e.preventDefault();
        }}
      >
        <ItinerarySegmentBanner onClick={onClick}>{children}</ItinerarySegmentBanner>
      </a>
    );
  },
);

export default ItinerarySegmentBannerWithRef;
